import React from 'react'
import AdsPage from '..'

const MobileAdsPage = () => {
  return (
    <AdsPage endpointType="mobile" />
  )
}

export default MobileAdsPage